import Vue from 'vue';

// 定义过滤器对象，包含多个过滤器函数
const filters = {
  formatNumber(value) {
    if (typeof value !== 'number') {
      return value;
    }
    if (value < 0) {
      return 0.0;
    }
    return value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  },
  formatNumber2(value) {
    if (typeof value !== 'number') {
      return value;
    }
    if (value < 0) {
      return 0.0;
    }
    let num = value.toFixed(3).toString();
    let newNum = num.substring(0, num.lastIndexOf('.') + 3);
    return newNum;
  },
  percentage(num) {
    let value = (num * 100).toFixed(1) + '%';
    return value;
  },
  uppercase(value) {
    if (typeof value !== 'string') {
      return value;
    }
    return value.toUpperCase();
  },
  // 添加更多过滤器函数...
};

// 使用循环来注册过滤器
Object.keys(filters).forEach((filterName) => {
  Vue.filter(filterName, filters[filterName]);
});
